import Upsertable from '@/models/Upsertable'
import { useBusinessStore } from '@/stores/businessStore'
import { useModelName } from '@/composables/useModelName.js'
import { ModelRegistry } from '@/models/modelRegistry.js'

export default class Business extends Upsertable {
  static store() {
    return useBusinessStore()
  }

  store() {
    return Business.store()
  }
}

useModelName(Business, "Business")
ModelRegistry.register(Business, "Business")